export const TZ = "Asia/Kuala_Lumpur";

export const formatClassAt = (iso, lang = "ms") => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const loc = lang === "en" ? "en-GB" : "ms-MY";
  const date = new Intl.DateTimeFormat(loc, { timeZone: TZ, day: "numeric", month: "short", year: "numeric" }).format(d);
  const time = new Intl.DateTimeFormat("en-US", { timeZone: TZ, hour: "numeric", minute: "2-digit", hour12: true }).format(d);
  return `${date} · ${time}`.toUpperCase();
};

// ISO -> "YYYY-MM-DDTHH:mm" in Malaysia time for <input type="datetime-local">
export const toMytInput = (iso) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return new Date(d.getTime() + 8 * 3600 * 1000).toISOString().slice(0, 16);
};

export const fromMytInput = (v) => (v ? `${v}:00+08:00` : "");
